import React, { useEffect } from 'react'
import { LinearProgress } from '@material-ui/core'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from '../../hooks/use-query'
import { NonprofitRequestQueryParams } from './non-profit-page.hooks'
import { useNonProfitPage } from './non-profit-page.hooks'
import { QueryParams } from './non-profits-component/non-profits-page.constants'
import { NonProfitsComponent } from './non-profits-component/non-profits.component'
import { nonprofitsApi } from '../../services/api/nonprofits'

export const NonProfitsPage: React.FC = () => {
  const urlQuery = useQuery()
  const navigate = useNavigate()
  const location = useLocation()
  const {
    loading,
    query,
    firstRender,
    categories,
    isFilterCollapsed,
    nonprofits,
    setQuery,
    setNonprofits,
    setLoading,
    setIsFilterCollapsed,
  } = useNonProfitPage()

  /*Get Nonprofits List*/
  const fetchNonrofits = async (query: NonprofitRequestQueryParams) => {
    setLoading(true)
    try {
      const nonprofits = await nonprofitsApi.lookupData({
        pageIndex: `${query.pageIndex}`,
        pageSize: `${query.pageSize}`,
        categoryId: query.nonprofitCategoryId || ('' as any),
        searchName: query.searchText,
      })
      setNonprofits([...nonprofits] as any)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  /* Change Query Handler*/
  const changeQueryParamsAction = (
    data: QueryParams,
    isApply?: boolean,
    isStartPagingInBegin?: boolean
  ) => {
    setQuery({ ...query, ...data })
    const { pageIndex, pageSize, nonprofitCategoryId, searchText } = data
    const _pageSize = pageSize ? pageSize : query!.pageSize

    // eslint-disable-next-line functional/no-let
    let _pageIndex = pageIndex ? pageIndex : query!.pageIndex
    _pageIndex = isStartPagingInBegin ? 1 : _pageIndex
    const _nonprofitCategoryId =
      nonprofitCategoryId || nonprofitCategoryId === null
        ? nonprofitCategoryId
        : query!.nonprofitCategoryId

    const _searchText = searchText ? searchText : query!.searchText

    const transformToUrlString = () => {
      if (_nonprofitCategoryId) {
        return `&nonprofitCategoryId=${_nonprofitCategoryId}`
      } else {
        return ''
      }
    }

    isApply &&
      navigate(
        `/nonprofit-catalog?pageIndex=${_pageIndex}&pageSize=${_pageSize}&searchText=${_searchText}${transformToUrlString()}`
      )
  }

  /*Get Query Data From Url*/
  const getQueryDataFromUrl = (
    urlQuery: URLSearchParams
  ): NonprofitRequestQueryParams => {
    const fromUrlPageIndex = urlQuery.get('pageIndex')
    const fromUrlPageSize = urlQuery.get('pageSize')
    const fromUrlNonprofitCategoryId = urlQuery.get('nonprofitCategoryId')
    const fromUrlSearchText = urlQuery.get('searchText')

    return {
      pageIndex: fromUrlPageIndex
        ? Number(fromUrlPageIndex)
        : query?.pageIndex || 1,
      pageSize: fromUrlPageSize
        ? Number(fromUrlPageSize)
        : query?.pageSize || 1,
      nonprofitCategoryId: fromUrlNonprofitCategoryId
        ? Number(fromUrlNonprofitCategoryId)
        : null,
      searchText: fromUrlSearchText || '',
    }
  }

  useEffect(() => {
    const _query = getQueryDataFromUrl(urlQuery)
    setQuery(_query)
    fetchNonrofits(_query)
  }, [location])

  /*Cancel Handler*/
  const cancelHandler = () => {
    navigate(
      `/nonprofit-catalog?pageIndex=&pageSize=&searchText=&nonprofitCategoryId=`
    )
  }

  /*Filter Collapsed Handler*/
  const changeFilterCollapsedHandler = (value: boolean) => {
    setIsFilterCollapsed(value)
  }

  return (
    <>
      <LinearProgress style={{ visibility: loading ? 'visible' : 'hidden' }} />
      <NonProfitsComponent
        isFilterCollapsed={isFilterCollapsed}
        loading={loading}
        firstRender={firstRender}
        query={query as NonprofitRequestQueryParams}
        totalPages={0}
        cancelHandler={cancelHandler}
        changeQueryParamsAction={changeQueryParamsAction}
        categories={categories}
        changeFilterCollapsedHandler={changeFilterCollapsedHandler}
        nonprofits={nonprofits}
        needApply={false}
        searchText=""
      />
    </>
  )
}
